module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_344763.849a5a75.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/img_on_amazon/FormatoSimplificado_344763.pdf
// module id = 323
// module chunks = 0